import { useEffect } from 'react';

export default function VersionChecker() {
  const APP_VERSION = process.env.REACT_APP_VERSION;

  useEffect(() => {
    if (!APP_VERSION) return;

    // Compare with previous version stored in localStorage
    const previousVersion = localStorage.getItem('APP_VERSION');

    if (previousVersion && previousVersion !== APP_VERSION) {
      console.log('New version detected. Reloading...');
      localStorage.setItem('APP_VERSION', APP_VERSION);
      window.location.reload(true); // auto reload for fresh UI
    } else if (!previousVersion) {
      localStorage.setItem('APP_VERSION', APP_VERSION);
    }

    // Optional: check periodically in case app stays open
    const interval = setInterval(() => {
      const storedVersion = localStorage.getItem('APP_VERSION');
      if (storedVersion && storedVersion !== APP_VERSION) {
        console.log('New version detected. Reloading...');
        localStorage.setItem('APP_VERSION', APP_VERSION);
        window.location.reload(true);
      }
    }, 5 * 60 * 1000); // every 5 min

    return () => clearInterval(interval);
  }, [APP_VERSION]);

  return null;
}